import React, { useEffect, useState } from "react";
import subscriberApi from "@/lib/subscriberApi";
import { fmtDate } from "@/lib/utils-app";
import { Swords } from "lucide-react";

export default function SubscriberFights() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    subscriberApi.get("/subscriber/fights").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <section className="space-y-4" data-testid="subscriber-fights-page">
      <h1 className="font-display text-4xl text-white">Mis peleas</h1>
      <p className="text-sm text-white/60">Historial registrado por el gimnasio. Solo consulta.</p>

      <div className="space-y-4">
        {items.map((f) => (
          <article key={f.id} className="glass rounded-sm p-4">
            <div className="font-display text-xl text-white flex items-center gap-2">
              <Swords size={18} className="text-[#E63946]" />
              {fmtDate(f.fight_date)}
            </div>
            <div className="mt-2 grid sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-1 text-sm text-white/60">
              <span><span className="text-white/40">Lugar:</span> {f.location || "—"}</span>
              <span><span className="text-white/40">Categoría:</span> {f.category || "—"}</span>
              <span><span className="text-white/40">Peso:</span> {f.weight_kg != null ? `${f.weight_kg} kg` : "—"}</span>
            </div>
            {(f.images || []).length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {f.images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Pelea ${i + 1}`}
                    className="h-28 w-28 object-cover rounded-sm border border-white/10"
                  />
                ))}
              </div>
            )}
          </article>
        ))}
        {items.length === 0 && (
          <div className="glass p-10 text-center text-white/40">Aún no hay peleas registradas.</div>
        )}
      </div>
    </section>
  );
}
